<template>
  <div>
    <div v-if="sheet">

      <h1 id="tabletitle1" style="display: none;">{{ $t('reports.titles.accompanying_sheet') }}</h1>
      <!-- informations générales -->
      <div class="table-responsive">
        <table :id="tableid + '1'" class="table">
          <tbody>
            <tr>
              <th>{{ $t('accompanying_sheet.snapshot') }}</th><td>{{ snapshot.title }}</td>
            </tr>
            <tr>
              <th>{{ $t('accompanying_sheet.job') }}</th><td>{{ sheet.job }}</td>
            </tr>
            <tr>
              <th>{{ $t('accompanying_sheet.profession') }}</th><td>{{ $t(sheet.isco) }}</td>
            </tr>
            <tr>
              <th>{{ $t('accompanying_sheet.snapshot_category') }}</th><td>{{ sheet.generic_snapshot ? $t('accompanying_sheet.generic') : $t('accompanying_sheet.focused') }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <h1 id="tabletitle2">{{ $t('accompanying_sheet.sources' ) }}</h1>
      <div v-for="(source, index) in displaySources" class="table-responsive">
        <table :id="tableid + '2source' + (index + 1) + (index > 0 ? 'nomargin' : '')" class="table">
          <tbody>
            <tr>
              <th>{{ index + 1 }}. {{ $t('accompanying_sheet.' + source.field.name) }}</th>
            </tr>
            <tr v-if="source.field.small">
              <td class="details">{{ $t('accompanying_sheet.small.' + source.field.name) }}</td>
            </tr>
          </tbody>
        </table>
        <table v-if="source.details" :id="tableid + '2sourcedetails' + (index + 1) + 'nomargin'" class="table">
          <tbody>
            <tr v-if="(sheet[source.details] + '').length < 50">
              <td>{{ $t('accompanying_sheet.' + source.details) }}: {{ sheet[source.details] }}</td>
            </tr>
            <tr v-if="(sheet[source.details] + '').length >= 50">
              <td class="subtitle">{{ $t('accompanying_sheet.' + source.details) }}:</td>
            </tr>
            <tr v-if="(sheet[source.details] + '').length >= 50">
              <td>{{ sheet[source.details] }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="table-responsive">
        <h1 id="tabletitle3">{{ $t('accompanying_sheet.authors') }}</h1>
        <div v-for="(author , index) in snapshot.contributors" v-if="snapshot.contributors.length > 0 && snapshot.contributors[0].pivot">
          <table :id="tableid + '3authors' + (index + 1)" class="table" >
            <tbody>
              <tr>
                <th>{{ $t('first_name') }}, {{ $t('last_name') }}</th>
                <td>{{ author.first_name }}, {{ author.last_name }}</td>
              </tr>
              <tr>
                <th>{{ $t('occupation') }}</th>
                <td>{{ author.occupation }}, {{ author.specialization }}</td>
              </tr>
              <tr>
                <th>{{ $t('email') }}</th>
                <td>{{ author.email }}</td>
              </tr>
              <tr>
                <th>{{ $t('location') }}</th>
                <td>{{ author.address }}, {{ author.location }}, {{ author.postal_code }}, {{ $t('nationalities.' + author.country) }}</td>
              </tr>
              <tr>
                <th>{{ $t('accompanying_sheet.authors_types.title') }}</th>
                <td>{{ author.pivot.skilled_writer ? $t('accompanying_sheet.authors_types.regular') : $t('accompanying_sheet.authors_types.occasional') }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div v-else>
          <table :id="tableid + '3authors' + (index + 1)" class="table">
            <tbody>
              <tr>
                <th>{{ $t('first_name') }}, {{ $t('last_name') }}</th>
                <td>{{ snapshot.created_by.first_name }}, {{ snapshot.created_by.last_name }}</td>
              </tr>
              <tr>
                <th>{{ $t('organization') }}</th>
                <td>{{ snapshot.created_by.organizationName }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="table-responsive">
        <h1 id="tabletitle4">{{ $t('accompanying_sheet.analyse_context') }}</h1>
        <div v-if="sheet.job_activities.length > 0">
          <h2 id="tabletitle4-1">{{ $t('accompanying_sheet.main_activities') }}</h2>
          <table :id="tableid + '4activities1'" class="table">
            <tbody>
              <tr>
                <td class="details">
                  {{ $t('accompanying_sheet.small.main_activities') }}
                </td>
              </tr>
            </tbody>
          </table>
          <table :id="tableid + '4activities2nomargin'" class="table">
            <tbody>
              <tr>
                <th>{{ $t('accompanying_sheet.activity_name') }}</th>
                <th>{{ $t('accompanying_sheet.frequency') }}</th>
              </tr>
              <tr v-for="(act, index) in sheet.job_activities">
                <td>{{ act.name }}</td>
                <td>{{ act.frequency }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div v-for="(text, index) in text_fields">
          <h2 :id="'tabletitle5-'+ (index + 1)">{{ $t('accompanying_sheet.' + text.name) }}</h2>
          <table v-if="text.small" :id="tableid + '5context' + (index + 1)" class="table">
            <tbody>
              <tr>
                <td class="details">
                  {{ $t('accompanying_sheet.small.' + text.name) }}
                </td>
              </tr>
            </tbody>
          </table>
          <table v-if="text.fields.length > 1" :id="tableid + '5context' + (index + 1) + (text.small ? 'nomargin' : '')" class="table">
            <tbody>
              <template v-for="(field, i) in text.fields">
                <tr>
                  <td class="subtitle">{{ $t('accompanying_sheet.'+field) }}:</td>
                </tr>
                <tr v-if="sheet[field]">
                  <td>{{ sheet[field] }}</td>
                </tr>
              </template>
            </tbody>
          </table>
          <table v-else :id="tableid + '5context' + (index + 1) + (text.small ? 'nomargin' : '')" class="table">
            <tbody>
              <tr v-for="(field, i) in text.fields">
                <td>{{ sheet[field] ? sheet[field] : '/' }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div v-for="(c, index) in context" class="table-responsive">
        <h2 :id="'tabletitle6-'+ (index + 1)">{{ $t('accompanying_sheet.' + c.field.name) }}</h2>
        <table :id="tableid + '6context' + (index + 1)" class="table">
          <tbody>
            <tr v-if="c.field.details">
              <td class="details">{{ $t('accompanying_sheet.' + c.field.name) }}</td>
            </tr>
            <tr>
              <td>{{ sheet[c.field.name] ? $t('yes') : $t('no') }}</td>
            </tr>
          </tbody>
        </table>
        <table v-if="sheet[c.details]" :id="tableid + '6contextdetails' + (index + 1) + 'nomargin'" class="table">
          <tbody>
            <tr>
              <td>{{ sheet[c.details] }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div v-else>
      {{ $t('accompanying_sheet.errors.no_sheet') }}
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'

export default {
  name: 'AccompanyingSheetDisplay',

  props: {
    snapshot: {
      type: Object,
      required: false,
      default: {}
    },
    tableid: {
      type: String,
      required: true
    }
  },

  data: () => ({
    sources: [
      { field: { name: 'source_from_observations', small: false }, details: 'observations_time_months' },
      { field: { name: 'source_professional_advices', small: true }, details: 'professional_specialization' },
      { field: { name: 'source_enterprise_documents', small: false }, details: null },
      { field: { name: 'source_supervisor_spoken_informations', small: false }, details: null },
      { field: { name: 'source_descriptive_monographs', small: true }, details: 'monographs_list' },
      { field: { name: 'source_others', small: false }, details: 'others_list' }
    ],
    text_fields: [
      { name: 'required_skills', fields: ['required_qualifications', 'required_knowledges', 'required_experiences'], small: true },
      { name: 'job_status', fields: ['job_status'], small: true },
      { name: 'physical_environment', fields: ['physical_environment'], small: true },
      { name: 'physical_positions', fields: ['physical_positions'], small: false },
      { name: 'security_risks', fields: ['security_risks'], small: false },
      { name: 'main_difficulties', fields: ['main_difficulties'], small: true },
      { name: 'interactions_with_others', fields: ['interactions_with_others'], small: false },
      { name: 'social_environment', fields: ['social_environment'], small: true },
      { name: 'responsibilities', fields: ['responsibilities'], small: true },
      { name: 'supervisions', fields: ['human_supervision', 'technical_supervision'], small: true }
    ],
    context: [
      { field: { name: 'performances_standards', small: false }, details: 'expected_performances', type: 2 },
      { field: { name: 'work_organization_freedom', small: false }, details: 'possible_organization_adjustments', type: 2 }
    ],
    apiUrl: '/api/evaluations/requirements/'
  }),

  computed: {
    sheet: function () {
      if (this.snapshot) { return this.snapshot.accompanying_sheet }
      return null
    },
    displaySources: function () {
      if (this.sheet) {
        return this.sources.filter(s => this.sheet[s.field.name])
      }
      return this.sources
    }
  },

  methods: {

  },

  render () {

  }
}
</script>
<style>
.details {
  font-size: 0.8em;
  font-style: italic;
  padding: 0px;
  margin: 0px;
  border: none;
  color: #005187;
}

table[id*=nomargin] {
  margin: 0px;
  padding: 0px;
}

table[id*=nomargin] tbody tr td {
  margin: 100px;
}

.subtitle {
  text-decoration: underline;
  font-weight: bold;
}

h1 {
  font-size: 1.8em;
}

h2 {
  font-size: 1.4em;
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/js/components/AccompanyingSheetDisplay.vue